<template>
  <div class="vr360-app-main__online-stream">
      <div v-show="linkFinded">
        <div class="vr360-app-main__online-stream__header" v-if="isNewStream">
          <p class="vr360-live vr360-live--large vr360-text-reg vr360-text-white">
            <span>{{time | secondsTohhmmss}}</span>
          </p>
        </div>
        <div class="vr360-app-main__online-stream__canvas">
          <a-scene ref="scene">
            <!-- <a-plane position="0 1.9 -1.5" material="opacity: 0.3; transparent: true; color: blue"> -->
            <a-entity layout="type: line; margin: 1.5" position="0 0 -1.5">
              <a-text  v-if="!isNewStream && showUICanvas"
                      backbutton
                      ref="backBtn"
                      width="2.5"
                      opacity="0.2"
                      value="Back"
                      align="center"
                      position="0 1.9 -1.5"
                      color="white"
                      geometry="primitive:plane; height: 0.18;"
                      material="opacity: 0.0; transparent: true">
              </a-text>
              <a-text  v-if="showUICanvas"
                      startbutton 
                      ref="togglePlay"
                      width="2.5"
                      opacity="0.2"
                      :value="stateVideo"
                      align="center"
                      position="0 1.7 -1.5"
                      color="white"
                      geometry="primitive:plane; height: 0.18;"
                      material="opacity: 0.0; transparent: true">
              </a-text>
            <!-- </a-plane> -->
            </a-entity>
              
            <!-- <div class="back">
                
            </div> -->
            <a-videosphere rotation="0 180 0" src="#video">
            </a-videosphere>

            <!-- <a-entity id="play-button" geometry="primitive: box" material="color: red" position="0 0 -2" :click="togglePlay">Play/pause</a-entity> -->

            <a-camera v-if="showUICanvas">
              <a-entity cursor="fuse: false" position="0 0 -1.5" geometry="primitive:ring; radiusInner: 0.02; radiusOuter: 0.03"></a-entity>
            </a-camera>

            <a-assets>
              <video id="video" ref="videoPlayer"
                    loop playsinline webkit-playsinline crossorigin="anonymous">
                <source :src="sourceVideo" :type="isStream ? 'application/x-mpegURL' : 'video/mp4'" crossorigin="anonymous" />
              </video>
            </a-assets>
          </a-scene>
        </div>
        <div class="vr360-app-main__online-stream__bottom" v-if="isNewStream">
            <!-- <div class="vr360-app-main__online-stream__btn vr360-app-main__online-stream__btn--volume-btn">
              <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 19L13.5 0.999999L6.60638 5.61883L1.5 5.61883L1.5 14.8564L6.60638 14.8564L13.5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M17.5 5C19.4496 5.9026 20.5 7.65324 20.5 10C20.5 12.3468 19.4496 14.0974 17.5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M20.5 3C23.0995 4.26364 24.5 6.71454 24.5 10C24.5 13.2855 23.0995 15.7364 20.5 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div> -->
            <button 
                class="vr360-app-main__online-stream__btn 
                  vr360-app-main__online-stream__btn--play-btn 
                  js-playing"
                  style="margin: 0 auto;"
                  @click="stopStream"
                  >
              <span class="vr360-head-h2 vr360-text-white">Stop</span>
            </button>
            <!-- <div class="vr360-app-main__online-stream__btn vr360-app-main__online-stream__btn--quality-btn">
              <span class="vr360-head-h4 vr360-text-white">8K</span>
            </div> -->
          </div>
      </div>
      <div class="vr360-flex-column vr360-spinner vr360-spinner--fixed" v-show="!linkFinded">
        <img class="vr360-spinner__img" src="@/assets/img/app/loader.png" alt="">
        <p class="vr360-head-h2">Waiting to start streaming</p>
        <p class="vr360-text-reg">{{ stream.title }}</p>
        <template v-if="isNewStream">
          <router-link 
                        class="vr360-btn vr360-btn--red"
                        :to="{ name: 'ListMyStreams', params: { filter: 'all' } }"
                        @click.native="removeStream(stream.id)"
          >
            <span>Cancel</span> 
          </router-link>
        </template>
        <template v-else>
          <router-link
                        class="vr360-btn vr360-btn--red"
                        :to="{ name: 'ListMyStreams', params: { filter: 'all' } }"
          >
            <span>Cancel</span> 
          </router-link>
        </template>
      </div>
  </div>
</template>

<script>
/* global AFRAME */

import Hls from "hls.js";
import api from "@/api/stream";

import "aframe";

import { mapActions, mapGetters } from "vuex";

import playBtn from "../../assets/js/aframe/componentPlay.js";
import backBtn from "../../assets/js/aframe/componentBack.js";

import checkURL from "@/assets/js/checkURL";

export default {
  name: "ShowStream",
  data() {
    return {
      script: null,
      sourceVideo: "",
      stateVideo: "Play",
      time: 0,
      isStream: false,
      isNewStream: false,
      linkFinded: false,
      showUICanvas: true,
      windowListenerAdded: false
    };
  },
  created() {
    this.hls = null;

    this.isNewStream = this.$route.query.new;
    if (!this.stream.id) {
      this.$router.go(-1);
    } else {
      this.isStream = !!this.stream.link_hls.match(".m3u8");

      if (this.isStream && !window.Hls) {
        this.script = document.createElement("script");
        this.script.src = "/js/hls.js";
        document.body.appendChild(this.script);
      }

      this.checkStreamLink(this.stream.link_hls);
    }
  },
  mounted() {
    if (!this.isNewStream) {
      playBtn(this);
      backBtn(this);
    }
  },
  beforeDestroy() {},
  destroyed() {
    document.body.classList.remove("a-body");
    document.documentElement.classList.remove("a-html");

    if (this.hls) {
      this.hls.destroy();
    }

    if (this.isStream) {
      window.Hls = null;

      this.script.remove();
      this.script = null;
    }

    if (!this.isNewStream) {
      delete AFRAME.components["backbutton"];
      delete AFRAME.components["startbutton"];
    }

    this.linkFinded = true;
  },
  methods: {
    ...mapActions({
      update: "stream/updateStream",
      removeStream: "stream/removeStream",
      updateOnStopOfStream: "stream/updateOnStopOfStream",
      showSpinner: "showSpinner",
      showNotification: "showNotification",
      hideSpinner: "hideSpinner"
    }),
    handlerAutoplay() {
      if (!this.windowListenerAdded) {
        this.windowListenerAdded = true;

        setTimeout(() => {
          if (this.time === 0) {
            this.showNotification({
              message: "If video dont start, touch the screen",
              type: "success"
            });

            document.body.addEventListener("touchstart", this.startPlay);
          }
        }, 6000);
      }
    },
    startPlay() {
      const video = this.$refs.videoPlayer;

      video.play();
      if (!video.paused) this.stateVideo = "Pause";

      document.body.removeEventListener("touchstart", this.startPlay);
    },
    checkHls() {
      const video = this.$refs.videoPlayer;
      video.ontimeupdate = () => {
        this.time = parseInt(video.currentTime);
      };

      if (this.isStream) {
        if (window.Hls) {
          if (window.Hls.isSupported()) {
            this.hls = new Hls();
            this.hls.loadSource(this.stream.link_hls);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
              if (!this.stream.live) {
                this.hls.startLoad(0);
              }

              video.play();
              if (!video.paused) this.stateVideo = "Pause";

              this.handlerAutoplay();
            });

            this.handlerAutoplay();
          } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = this.stream.link_hls;
            video.addEventListener('loadedmetadata',function() {
              video.play();

              if (!video.paused) this.stateVideo = "Pause";

              this.handlerAutoplay();
            });
          }
        } else {
          setTimeout(this.checkHls, 20);
        }
      } else {
        video.play();
        if (!video.paused) this.stateVideo = "Pause";

        this.handlerAutoplay();
      }
    },
    prepareVideo() {
      const video = this.$refs.videoPlayer;

      video.ontimeupdate = () => {
        this.time = parseInt(video.currentTime);
      };

      this.sourceVideo = this.stream.link_hls;
      video.load();
      video.play();

      if (!video.paused) this.stateVideo = "Pause";

      this.handlerAutoplay();
    },
    checkStreamLink(url) {
      if (!this.linkFinded) {
        checkURL(url).then(result => {
          if (result) {
            this.linkFinded = true;

            api.updateStat(this.$route.params.id);

            if (this.isStream) {
              this.checkHls();
            } else {
              this.prepareVideo();
            }
          } else {
            setTimeout(() => {
              this.checkStreamLink(url);
            }, 2000);
          }
        });
      }
    },
    stopStream() {
      this.updateOnStopOfStream({ id: this.stream.id, duration: this.time });
      this.$router.replace({
        name: "FinishStream",
        params: { id: this.stream.id }
      });
    }
  },
  computed: {
    ...mapGetters({
      stream: "stream/currentStream"
    })
  }
};
</script>

<style lang="scss">
a-scene {
  z-index: 3;
}
.vr360-app-main__online-stream__header,
.vr360-app-main__online-stream__bottom {
  z-index: 4;
}
.back {
  position: fixed;
  top: 20px;
  left: 40px;
  z-index: 9999;
  color: #fff;
}
a-scene.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
}
a-scene.fullscreen .back {
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
}
</style>
